import { render, staticRenderFns } from "./BookingHotel.vue?vue&type=template&id=327006eb&"
import script from "./BookingHotel.vue?vue&type=script&lang=js&"
export * from "./BookingHotel.vue?vue&type=script&lang=js&"
import style0 from "./BookingHotel.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports